var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14900",
    "data-name": "Group 14900",
    transform: "translate(-160 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36045",
    "data-name": "Path 36045",
    d: "M184,1157a8,8,0,1,0-8-8A8,8,0,0,0,184,1157Zm0,2a10,10,0,1,0-10-10A10,10,0,0,0,184,1159Z",
    transform: "translate(0 -601)",
    fill: "#141416",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36046",
    "data-name": "Path 36046",
    d: "M184,1143a1,1,0,0,1,1,1v4.59l2.207,2.2a1,1,0,0,1-1.414,1.42l-2.5-2.5A1,1,0,0,1,183,1149v-5A1,1,0,0,1,184,1143Z",
    transform: "translate(0 -601)",
    fill: "#141416",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path_36391",
    "data-name": "Path 36391",
    width: 46,
    height: 46,
    rx: 23,
    transform: "translate(161 525)",
    fill: "none",
    stroke: "#867cff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTimeIcon);
export default __webpack_public_path__ + "static/media/circleTimeIcon.cb0d2f1b649be068ad1d0bf5f5786576.svg";
export { ForwardRef as ReactComponent };